module.exports = __webpack_public_path__ + "img/YMESicon2.0a2cf1e2.png";